// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Platform.css */
.platform-container {
  text-align: center;
}
.platform-container .platform-title {
  margin: 0;
  padding: 20px 0;
  font-size: 22px;
  font-weight: bold;
}
.platform-container .video-container {
  display: flex;
  justify-content: center;
  padding: 20px 0;
}
.platform-container .video-container .platform-video {
  max-width: 100%;
  height: 250px;
}
.platform-container .text-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 40px;
}
.platform-container .text-container .platform-link,
.platform-container .text-container .platform-text {
  font-size: 13px;
  margin: 0 5px;
  text-decoration: none;
}
.platform-container .text-container .platform-text {
  color: #7f7f7f;
}
@media (max-width: 768px) {
  .platform-title {
    font-size: 24px;
  }
  .platform-video {
    width: 90%;
  }
  .platform-link,
  .platform-text {
    font-size: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/login/index.less"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;EACE,kBAAA;AACF;AAFA;EAGI,SAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;AAEJ;AARA;EAUI,aAAA;EACA,uBAAA;EACA,eAAA;AACJ;AAbA;EAeM,eAAA;EACA,aAAA;AACN;AAjBA;EAsBI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;AAFJ;AAvBA;;EA4BM,eAAA;EACA,aAAA;EACA,qBAAA;AADN;AA7BA;EAkCM,cAAA;AAFN;AASA;EACE;IACE,eAAA;EAPF;EAUA;IACE,UAAA;EARF;EAWA;;IACE,eAAA;EARF;AACF","sourcesContent":["/* Platform.css */\n.platform-container {\n  text-align: center;\n  .platform-title {\n    margin: 0;\n    padding: 20px 0;\n    font-size: 22px;\n    font-weight: bold;\n  }\n\n  .video-container {\n    display: flex;\n    justify-content: center;\n    padding: 20px 0;\n\n    .platform-video {\n      max-width: 100%;\n      height: 250px;\n    }\n\n  }\n\n  .text-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding-bottom: 40px;\n\n    .platform-link, .platform-text {\n      font-size: 13px;\n      margin: 0 5px;\n      text-decoration:none;\n    }\n\n    .platform-text {\n      color: #7f7f7f;\n    }\n\n  }\n\n}\n\n@media (max-width: 768px) {\n  .platform-title {\n    font-size: 24px;\n  }\n\n  .platform-video {\n    width: 90%;\n  }\n\n  .platform-link, .platform-text {\n    font-size: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
